import { useState } from 'react';
import Button from '@/components/elements/Button';
import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksTabContentBlock, IComponentSharedTab } from '@/graphql/__generated__/global/types';
import classNames from '@/lib/classNames';
import BlockRichTextColumns from '../RichTextColumns/RichTextColumns';

export const TabContentBlock = ({ titleDescription, tabs }: IComponentBlocksTabContentBlock) => {
    const [activeTab, setActiveTab] = useState<IComponentSharedTab | undefined>(tabs && tabs[0]);

    return (
        <Container bg="shell" rounded={true} wrapperClassName={'py-16'}>
            {titleDescription && <TitleAndDescription className="pb-10" {...titleDescription} />}
            <div className="flex items-center justify-center mb-8 sm:mb-16">
                <div
                    className={classNames(
                        'bg-rock p-4 text-primary text-center rounded-3xl w-full flex flex-col items-center justify-center gap-2',
                        tabs.length > 3 ? 'lg:w-auto lg:rounded-full lg:flex-row' : 'sm:w-auto sm:rounded-full sm:flex-row'
                    )}
                >
                    {tabs.map((tab, i) => {
                        const Heading = tab.headingLevel ?? 'h6';
                        const isActive = activeTab ? activeTab.title === tab.title : i === 0;

                        return (
                            <Button
                                asChild
                                key={i}
                                variant={isActive ? 'fill' : 'ghost'}
                                colour={isActive ? 'white' : 'primary'}
                                className="h6 w-full sm:w-auto cursor-pointer aria-pressed:pointer-events-none"
                            >
                                <Heading
                                    id={i.toString()}
                                    role="button"
                                    tabIndex={0}
                                    aria-pressed={isActive}
                                    onClick={() => setActiveTab(tab)}
                                    onKeyDown={(event) => {
                                        if (event.key !== 'Enter' && event.key !== ' ') {
                                            return;
                                        }

                                        event.preventDefault();
                                        setActiveTab(tab);
                                    }}
                                >
                                    {tab.title}
                                </Heading>
                            </Button>
                        );
                    })}
                </div>
            </div>
            {activeTab && activeTab.columns?.length && <BlockRichTextColumns addPaddingX={false} id={activeTab.id} richTextColumns={activeTab.columns} />}
        </Container>
    );
};
